export interface PlanFeature {
  name: string;
  description: string;
  included: boolean;
  limit?: number;
}

export interface Plan {
  id: string;
  name: string;
  price: number;
  interval: 'month' | 'year';
  description: string;
  features: PlanFeature[];
  stripePriceId?: string; // We'll add this later when we set up Stripe
  popular?: boolean;
}

export const FREE_PLAN_ID = 'free';
export const PRO_PLAN_ID = 'pro';

export const PLANS: Plan[] = [
  {
    id: FREE_PLAN_ID,
    name: 'Free',
    price: 0,
    interval: 'month',
    description: 'Perfect for getting started with prompt engineering',
    features: [
      {
        name: 'Prompt Refining',
        description: 'Refine your prompts for better results',
        included: true,
        limit: 50
      },
      {
        name: 'Prompt Score Checker',
        description: 'Check the quality of your prompts',
        included: true,
        limit: 50
      },
      {
        name: 'History Access',
        description: 'Access your prompt history',
        included: true
      },
      {
        name: 'Template Access',
        description: 'Access to prompt templates',
        included: false
      },
      {
        name: 'Chrome Extension',
        description: 'Use PromptPerfect in your browser',
        included: false
      },
      {
        name: 'Refinement Level',
        description: 'Basic refinement capabilities',
        included: true
      }
    ]
  },
  {
    id: PRO_PLAN_ID,
    name: 'Pro',
    price: 15,
    interval: 'month',
    description: 'For power users who need unlimited access',
    popular: true,
    features: [
      {
        name: 'Prompt Refining',
        description: 'Unlimited prompt refinements',
        included: true
      },
      {
        name: 'Prompt Score Checker',
        description: 'Unlimited prompt quality checks',
        included: true
      },
      {
        name: 'History Access',
        description: 'Unlimited history access',
        included: true
      },
      {
        name: 'Template Access',
        description: 'Access to all prompt templates',
        included: true
      },
      {
        name: 'Chrome Extension',
        description: 'Use PromptPerfect anywhere',
        included: true
      },
      {
        name: 'Community Access',
        description: 'Access to exclusive community',
        included: true
      },
      {
        name: 'Refinement Level',
        description: 'Advanced refinement capabilities',
        included: true
      }
    ]
  }
];

export const getPlanById = (planId: string): Plan | undefined => {
  return PLANS.find(plan => plan.id === planId);
};

export const isPlanFeatureAvailable = (plan: Plan, featureName: string): boolean => {
  const feature = plan.features.find(f => f.name === featureName);
  return feature?.included || false;
};

export const getPlanFeatureLimit = (plan: Plan, featureName: string): number | undefined => {
  const feature = plan.features.find(f => f.name === featureName);
  return feature?.limit;
};

export const isProFeature = (featureName: string): boolean => {
  const freePlan = PLANS.find(plan => plan.id === FREE_PLAN_ID);
  if (!freePlan) return true;
  return !isPlanFeatureAvailable(freePlan, featureName);
}; 